export enum TypeAdres {
	Post = 1,
	Bezoek = 2,
	Certificaat = 3,
	Verzenden = 4,
	Overig = 5
}